export const BUY_HORSE_ANALYSIS_PRESSED = 'BUY_HORSE_ANALYSIS_PRESSED';
export const HORSE_INFO_DATA_UPDATED = 'HORSE_INFO_DATA_UPDATED';
export const VIEW_HORSEINFO_RACE = 'VIEW_HORSEINFO_RACE';
export const VIEW_RACE_ANALYSIS = 'VIEW_RACE_ANALYSIS';
export const POPUP_INTERACTION = 'POPUP_INTERACTION';
export const CURRENT_INPUT_CHANGE = 'CURRENT_INPUT_CHANGE';
export const ARCHIVE_DELETE_COMPLETED = 'ARCHIVE_DELETE_COMPLETED';
export const GRID_ON_OVERLAY_PRESSED = 'GRID_ON_OVERLAY_PRESSED';
